/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TerminalEventDto
 */
export interface TerminalEventDto {
    /**
     * 
     * @type {TerminalEventDtoEventCodeEnum}
     * @memberof TerminalEventDto
     */
    eventCode: TerminalEventDtoEventCodeEnum;
    /**
     * 
     * @type {TerminalEventDtoNewStateEnum}
     * @memberof TerminalEventDto
     */
    newState: TerminalEventDtoNewStateEnum;
    /**
     * 
     * @type {string}
     * @memberof TerminalEventDto
     */
    payload?: string;
    /**
     * 
     * @type {Date}
     * @memberof TerminalEventDto
     */
    receivedFromPsp?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TerminalEventDto
     */
    pspEventTimestamp?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TerminalEventDto
     */
    created?: Date;
}


/**
 * @export
 */
export const TerminalEventDtoEventCodeEnum = {
    PAYMENT_RESPONSE: 'PAYMENT_RESPONSE',
    SHUTDOWN: 'SHUTDOWN',
    BEGIN_MAINTENANCE: 'BEGIN_MAINTENANCE',
    END_MAINTENANCE: 'END_MAINTENANCE',
    OUT_OF_ORDER: 'OUT_OF_ORDER',
    INITIALISED: 'INITIALISED',
    NETWORK_CONNECTED: 'NETWORK_CONNECTED',
    NETWORK_DISCONNECTED: 'NETWORK_DISCONNECTED',
    REJECT: 'REJECT',
    SALE_WAKE_UP: 'SALE_WAKE_UP',
    COMPLETED: 'COMPLETED',
    ASK_GRATUITY: 'ASK_GRATUITY',
    GRATUITY_ENTERED: 'GRATUITY_ENTERED',
    TENDER_CREATED: 'TENDER_CREATED',
    CARD_PRESENTED: 'CARD_PRESENTED',
    CARD_INSERTED: 'CARD_INSERTED',
    WAIT_FOR_PIN: 'WAIT_FOR_PIN',
    PIN_ENTERED: 'PIN_ENTERED',
    CARD_REMOVED: 'CARD_REMOVED',
    CARD_SWIPED: 'CARD_SWIPED',
    PRINT_RECEIPT: 'PRINT_RECEIPT',
    TENDER_FINAL: 'TENDER_FINAL',
    WAIT_FOR_APP_SELECTION: 'WAIT_FOR_APP_SELECTION',
    APPLICATION_SELECTED: 'APPLICATION_SELECTED',
    ASK_SIGNATURE: 'ASK_SIGNATURE',
    CHECK_SIGNATURE: 'CHECK_SIGNATURE',
    SIGNATURE_CHECKED: 'SIGNATURE_CHECKED',
    PIN_DIGIT_ENTERED: 'PIN_DIGIT_ENTERED',
    RECEIPT_PRINTED: 'RECEIPT_PRINTED',
    ASK_DCC: 'ASK_DCC',
    DCC_ACCEPTED: 'DCC_ACCEPTED',
    DCC_REJECTED: 'DCC_REJECTED',
    BALANCE_QUERY_STARTED: 'BALANCE_QUERY_STARTED',
    BALANCE_QUERY_COMPLETED: 'BALANCE_QUERY_COMPLETED',
    LOAD_STARTED: 'LOAD_STARTED',
    LOAD_COMPLETED: 'LOAD_COMPLETED',
    PROVIDE_CARD_DETAILS: 'PROVIDE_CARD_DETAILS',
    CARD_DETAILS_PROVIDED: 'CARD_DETAILS_PROVIDED',
    DIAGNOSIS: 'DIAGNOSIS',
    INITIATE_DIAGNOSIS: 'INITIATE_DIAGNOSIS'
} as const;
export type TerminalEventDtoEventCodeEnum = typeof TerminalEventDtoEventCodeEnum[keyof typeof TerminalEventDtoEventCodeEnum];

/**
 * @export
 */
export const TerminalEventDtoNewStateEnum = {
    UNKNOWN: 'UNKNOWN',
    OK: 'OK',
    BUSY: 'BUSY',
    MAINTENANCE: 'MAINTENANCE',
    UNREACHABLE: 'UNREACHABLE',
    OUT_OF_ORDER: 'OUT_OF_ORDER'
} as const;
export type TerminalEventDtoNewStateEnum = typeof TerminalEventDtoNewStateEnum[keyof typeof TerminalEventDtoNewStateEnum];


/**
 * Check if a given object implements the TerminalEventDto interface.
 */
export function instanceOfTerminalEventDto(value: object): value is TerminalEventDto {
    if (!('eventCode' in value) || value['eventCode'] === undefined) return false;
    if (!('newState' in value) || value['newState'] === undefined) return false;
    return true;
}

export function TerminalEventDtoFromJSON(json: any): TerminalEventDto {
    return TerminalEventDtoFromJSONTyped(json, false);
}

export function TerminalEventDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TerminalEventDto {
    if (json == null) {
        return json;
    }
    return {
        
        'eventCode': json['eventCode'],
        'newState': json['newState'],
        'payload': json['payload'] == null ? undefined : json['payload'],
        'receivedFromPsp': json['receivedFromPsp'] == null ? undefined : (new Date(json['receivedFromPsp'])),
        'pspEventTimestamp': json['pspEventTimestamp'] == null ? undefined : (new Date(json['pspEventTimestamp'])),
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
    };
}

export function TerminalEventDtoToJSON(json: any): TerminalEventDto {
    return TerminalEventDtoToJSONTyped(json, false);
}

export function TerminalEventDtoToJSONTyped(value?: TerminalEventDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eventCode': value['eventCode'],
        'newState': value['newState'],
        'payload': value['payload'],
        'receivedFromPsp': value['receivedFromPsp'] == null ? value['receivedFromPsp'] : value['receivedFromPsp'].toISOString(),
        'pspEventTimestamp': value['pspEventTimestamp'] == null ? value['pspEventTimestamp'] : value['pspEventTimestamp'].toISOString(),
        'created': value['created'] == null ? value['created'] : value['created'].toISOString(),
    };
}

